<template>
  <div class="form-group" :class="{ 'select-field': inline }">
    <strong class="label-holder">
      <label :for="id">{{ $t(label) }}</label>
    </strong>
    <span class="fake-select">
      <select :id="id" v-model="inputValue">
        <option :selected="value ===  null" disabled :value="null">
          {{ inline ? $t('general.select') : $t('general.please_select') }}
        </option>
        <option v-for="(option, key) in options" :key="key" :value="optionType === 'Object' ? option.value : option">
          {{ optionType === 'Object' ? option.label : option }}
        </option>
      </select>
    </span>
  </div>
</template>

<script>
export default {
  name: "input-select",
  props: {
    id: { type: String, default: "select", required: true },
    value: { required: true, default: null },
    options: { type: [Array, Number], required: true },
    label: { type: String, required: true },
    optionType: { type: String, default: 'Object' },
    inline: { type: Boolean, default: false }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("change", value);
        this.$emit("input", value);
      },
    },
  },
};
</script>